import { render } from "./Radio.vue?vue&type=template&id=3cadea59&scoped=true&ts=true"
import script from "./Radio.vue?vue&type=script&lang=ts"
export * from "./Radio.vue?vue&type=script&lang=ts"

import "./Radio.vue?vue&type=style&index=0&id=3cadea59&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cadea59"]])

export default __exports__